<form [formGroup]="form" (ngSubmit)="model ? update() : create()" appPermissionControl="P222F0001">
    <div class="form-row mt-3">
        <div class="form-field">
            <p-dropdown formControlName="cvetelefonista" 
            [options]="telefonistasDropdown" 
            optionLabel="susuario"
            optionValue="susuario" 
            [filter]="!model" 
            [showClear]="!model" 
            appendTo="body"
            placeholder="Seleccione clave telefonista"
            [disabled]="model !== null"
            [readonly]="model !== null"
            class="w-100" appPermissionControl="P222K0001"
            (onChange)="onTelefonistaSelected($event.value)">
                <ng-template let-usuario pTemplate="item">
                    {{ usuario.susuario }} | {{ usuario.nombreusuario }}
                </ng-template>
            </p-dropdown>
            <label>Clave Telefonista</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="numeroempleado" class="form-control"
                [placeholder]="'Ingrese número de empleado'" appPermissionControl="P222K0002">
            <label>N° Empleado</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="nombre" class="form-control"
                [placeholder]="'Ingrese nombres'" appPermissionControl="P222K0003" disabled>
            <label>Nombres</label>
        </div>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" type="submit" [disabled]="!form.valid || loading" appPermissionControl="P222B0001">
            <mat-icon>save</mat-icon>
            {{ model ? 'Actualizar' : 'Guardar' }}
        </button>
        <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="openCustomizables()" appPermissionControl="P222B0002">
            <mat-icon>tune</mat-icon>
            Customizables
        </button>
    </div>
</form>

<style>
    :host ::ng-deep .form-row {
        display: flex;
        flex-direction: row;
        margin-bottom: 1rem;
    }

    :host ::ng-deep .form-field {
        flex: 1;
        display: flex;
        flex-direction: column-reverse;
        position: relative;
    }

    :host ::ng-deep .form-control {
        width: 100%;
        padding: 0.5rem;
        font-size: 1rem;
        border: 1px solid #ced4da;
        border-radius: 4px;
        background: #fff;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    :host ::ng-deep .form-control:disabled {
        background: #e0e0e0 !important;
        color: #555 !important;
        opacity: 1 !important;
    }

    :host ::ng-deep .form-field label {
        font-size: 0.85rem;
        color: #6c757d;
        margin-bottom: 0.25rem;
    }

    :host ::ng-deep .button-section {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
        margin-top: 1.5rem;
    }

    /* Estilos para deshabilitar el dropdown solo en modo edición */
    :host ::ng-deep .p-dropdown.p-disabled,
    :host ::ng-deep .p-dropdown[disabled] {
        pointer-events: none !important;
        opacity: 0.7 !important;
        background-color: #e0e0e0 !important;
        cursor: not-allowed !important;
    }

    :host ::ng-deep .p-dropdown.p-disabled .p-dropdown-trigger,
    :host ::ng-deep .p-dropdown[disabled] .p-dropdown-trigger {
        display: none !important;
    }

    :host ::ng-deep .p-dropdown.p-disabled .p-dropdown-panel,
    :host ::ng-deep .p-dropdown[disabled] .p-dropdown-panel {
        display: none !important;
    }

    :host ::ng-deep .p-dropdown.p-disabled .p-dropdown-label,
    :host ::ng-deep .p-dropdown[disabled] .p-dropdown-label {
        color: #555 !important;
    }
</style> 